import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { BRIGGS_ICE_DEPTH, BRIGGS_ICE } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import DataActions from '../redux/dataRedux'
import { makeGetEventData } from '../selectors/eventDataSelector'
import union from '@turf/union'
import area from '@turf/area'
import { throttle, debounce } from 'throttle-debounce';

const url = ({ idToken, date }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/river-ice-churchill/${date}/{z}/{x}/{y}.pbf`

const id = 'RiverIceChurchill'
const datetimeId = 'RiverIceChurchill'
const authId = 'RiverIce'
const sourceLayer = 'rivericechurchill'

const getFeaturesAtPoint = (map, event, id) => {
  const features = map.queryRenderedFeatures(event.point, {
    layers: [id]
  })

  return features
}

const getFeaturesWithFilter = (map, id, features, sourceLayer, key, val) => {
  if (features.length === 0) {
    return []
  }

  const feature = features[0]
  const value = val || feature.properties[key]

  const result = map.querySourceFeatures(id, {
    sourceLayer,
    filter: ['==', key, value]
  })

  return result

}

const getTotalArea = (map, event, id, sourceLayer, key, value) => {
  const features = getFeaturesAtPoint(map, event, id)
  const results = getFeaturesWithFilter(map, id, features, sourceLayer, 'gridcode', value)
  const resultsUnion = union(...results)
  const totalArea = results.reduce((total, item) => {
    const itemArea = area(item)
    return total + itemArea
  }, 0)
  // console.log(totalArea)

  return totalArea
}

export class VectorLayer extends Component {
  componentDidMount () {
    const { map } = this.context
    if (!map) { return }
    map.on('mouseover', id, this.handleMouseOver)
    map.on('mouseout', id, this.handleMouseOut)
    map.on('mousemove', id, this.handleMouseMove)
    map.on('click', id, this.handleClick)
    map.on('moveend', id, debounce(500, this.handleMoveEnd))
    map.on('data', id, debounce(500, this.handleMoveEnd))
  }

  componentWillUnmount () {
    const { map } = this.context
    if (!map) { return }
    map.off('mouseover', id, this.handleMouseOver)
    map.off('mouseout', id, this.handleMouseOut)
    map.off('mousemove', id, this.handleMouseMove)
    map.off('click', id, this.handleClick)
    map.off('moveend', id, debounce(500, this.handleMoveEnd))
    map.off('data', id, debounce(500, this.handleMoveEnd))
  }

  handleMoveEnd = event => {
    return null
    const { map } = this.context
    const { actions } = this.props
    console.log('updating total areas')
    try {
      const totalArea = getTotalArea(map, event, id, sourceLayer, 'gridcode', 31)

      const values = [31, 32, 33]
      const totalAreas = values.reduce((totals, item) => {
        const totalArea = getTotalArea(map, event, id, sourceLayer, 'gridcode', item)
        const total = { x: item, y: totalArea, label: '' }
        totals.push(total)
        return totals
      }, [])
      // console.log(totalAreas)
      actions.pieChartDataUpdated(totalAreas)

      return totalArea
    } catch (error) {
      return null
    }
  }

  handleMouseMove = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })
    const data = features.map(feature => feature.properties)

    if (data) {
      actions.dataUpdated(data[0], 'hover')
    }
  }

  handleMouseOver = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    // console.log('mouse over', layerRendered)
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })

    map.getCanvas().style.cursor = features.length > 0 ? 'pointer' : ''
  }

  handleMouseOut = event => {
    const { map } = this.context
    const { actions } = this.props

    map.getCanvas().style.cursor = ''
    actions.dataUpdated({}, 'hover')
  }

  handleClick = event => {
    return null
    const { map } = this.context
    const { actions } = this.props
    try {
      const totalArea = getTotalArea(map, event, id, sourceLayer, 'gridcode', 31)

      const values = [31, 32, 33]
      const totalAreas = values.reduce((totals, item) => {
        const totalArea = getTotalArea(map, event, id, sourceLayer, 'gridcode', item)
        const total = { x: item, y: totalArea, label: '' }
        totals.push(total)
        return totals
      }, [])
      // console.log(totalAreas)
      actions.pieChartDataUpdated(totalAreas)

      return totalArea
    } catch (error) {
      return null
    }
  }



  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps.hovered !== this.props.hovered) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, hovered } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (!isEqual(props.hovered, hovered)) {
      if (hovered.id) {
        const filter = ['in', 'id'].concat(props.hovered.id)
        map.setFilter(`${id}Hovered`, filter)
      }
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time, datetime } = this.props
    const visible = layerRendered
    if (!visible) {
      return null
    }
    const timeIso = time ? new Date(time).toISOString() : ''

    const date = datetime.split('T')[0]

    const vectorSource = {
      type: 'vector',
      tiles: [url({ idToken, date })],
      tileSize: 512,
      maxzoom: 14
    }

    return (
      <div>
        <Source id={id} tileJsonSource={vectorSource} />
        <Layer
          type='fill'
          id={id}
          sourceId={id}
          sourceLayer={sourceLayer}
          paint={paint}
          filter={['!=', 'gridcode', 0]}
          />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getEventData = makeGetEventData()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, id),
      time: state.layer.times[datetimeId || id] || undefined,
      datetime: getDatetime(state, datetimeId || id) || '',
      hovered: getEventData(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event)),
      pieChartDataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, 'RiverIcePieChart', event))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(VectorLayer)



// WEBPACK FOOTER //
// ./src/layers/RiverIceChurchill.js